import { render } from "./Admin.Organisations.Modify.vue?vue&type=template&id=1758cdbc"
import script from "./Admin.Organisations.Modify.vue?vue&type=script&lang=js"
export * from "./Admin.Organisations.Modify.vue?vue&type=script&lang=js"

import "./Admin.Organisations.Modify.vue?vue&type=style&index=0&id=1758cdbc&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__